var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"references"},[_c('a',{attrs:{"href":"https://shimo.im/docs/MKI47rfGgw4a7CSg","target":"_blank"}},[_vm._v("计算规则")])])
}]

export { render, staticRenderFns }